import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ConfigProvider, App as AntdApp } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import './index.css'
import App from './App.tsx'
import { registerVTableEditors } from '@/pages/wuliuSeaWaybill/utils/registerEditors'

// ✅ 单一职责：注册编辑器
registerVTableEditors()

// 配置 dayjs 中文
dayjs.locale('zh-cn')

// 创建 QueryClient 实例
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ConfigProvider
        locale={zhCN}
        theme={{
          token: {
            colorPrimary: '#1677ff',
            borderRadius: 8,
            borderRadiusLG: 12,
            borderRadiusSM: 6,
            padding: 16,
            paddingLG: 24,
            paddingSM: 12,
            fontSize: 14,
            fontSizeLG: 16,
            fontSizeSM: 12,
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
            boxShadowSecondary: '0 4px 16px rgba(0, 0, 0, 0.12)',
          },
          components: {
            Card: {
              borderRadiusLG: 12,
              paddingLG: 24,
            },
            Table: {
              borderRadiusLG: 8,
              headerBg: '#fafafa',
              headerColor: 'rgba(0,0,0,0.88)',
              rowHoverBg: '#f5f5f5',
            },
            Button: {
              borderRadius: 6,
              controlHeight: 32,
              controlHeightLG: 40,
            },
            Input: {
              borderRadius: 6,
              controlHeight: 32,
            },
          },
        }}
      >
        <AntdApp message={{ duration: 3 }}>
          <App />
        </AntdApp>
      </ConfigProvider>
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  </StrictMode>
)
